import React from 'react';
import './Process.css';
import { useLanguage } from '../context/LanguageContext';

const Process = () => {
  const { t } = useLanguage();

  const steps = [
    {
      step: '01',
      icon: 'fa-comments-dollar',
      badge: t('process.s1Badge'),
      title: t('process.s1Title'),
      desc: t('process.s1Desc'),
      bullets: [
        t('process.s1B1'),
        t('process.s1B2'),
        t('process.s1B3')
      ]
    },
    {
      step: '02',
      icon: 'fa-layer-group',
      badge: t('process.s2Badge'),
      title: t('process.s2Title'),
      desc: t('process.s2Desc'),
      bullets: [
        t('process.s2B1'),
        t('process.s2B2'),
        t('process.s2B3')
      ]
    },
    {
      step: '03',
      icon: 'fa-code-compare',
      badge: t('process.s3Badge'),
      title: t('process.s3Title'),
      desc: t('process.s3Desc'),
      bullets: [
        t('process.s3B1'),
        t('process.s3B2'),
        t('process.s3B3')
      ]
    },
    {
      step: '04',
      icon: 'fa-shield-halved',
      badge: t('process.s4Badge'),
      title: t('process.s4Title'),
      desc: t('process.s4Desc'),
      bullets: [
        t('process.s4B1'),
        t('process.s4B2'),
        t('process.s4B3')
      ]
    },
    {
      step: '05',
      icon: 'fa-rocket',
      badge: t('process.s5Badge'),
      title: t('process.s5Title'),
      desc: t('process.s5Desc'),
      bullets: [
        t('process.s5B1'),
        t('process.s5B2'),
        t('process.s5B3')
      ]
    },
    {
      step: '06',
      icon: 'fa-headset',
      badge: t('process.s6Badge'),
      title: t('process.s6Title'),
      desc: t('process.s6Desc'),
      bullets: [
        t('process.s6B1'),
        t('process.s6B2'),
        t('process.s6B3')
      ]
    }
  ];

  return (
    <section className="process-section">
      <div className="section-header">
        <div className="section-badge">
          <i className="fa-solid fa-code-branch"></i>
          <span>{t('process.badge')}</span>
        </div>
        <h2 className="section-title">{t('process.title')}</h2>
        <p className="section-subtitle">{t('process.subtitle')}</p>
      </div>

      <div className="process-grid">
        {steps.map((item, idx) => (
          <div key={idx} className="process-card">
            <div className="process-card-header">
              <div className="process-number">{item.step}</div>
              <span className="process-badge">{item.badge}</span>
            </div>

            <div className="process-icon-box">
              <i className={`fa-solid ${item.icon}`}></i>
            </div>

            <h3 className="process-card-title">{item.title}</h3>
            <p className="process-card-desc">{item.desc}</p>

            <ul className="process-bullets">
              {item.bullets.map((b, bIdx) => (
                <li key={bIdx}>
                  <i className="fa-solid fa-check"></i>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Process;
